import { render, staticRenderFns } from "./orders-table.vue?vue&type=template&id=7ef7e486&"
import script from "./orders-table.vue?vue&type=script&lang=js&"
export * from "./orders-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports